import React from "react";
import { concatStringFromClassesArrayList } from "../../Utils";

export interface Props {
  url: string;
  text: string;
  variants?: string;
  classes?: string;
  onClick?: () => void;
}

export const HyperLink = (props: Props) => {
  const classList = {
    defaultClass: "",
    optionalClasses: [
      props.variants === "inPageLink" ? `ons-js-inpagelink` : "",
      props.classes ? props.classes : null,
    ],
  };
  const className = concatStringFromClassesArrayList(classList);

  return (
    <a
      href={props.url}
      onClick={props.onClick}
      data-testid="hyperLink"
      className={className}
    >
      {props.text}
    </a>
  );
};
